import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'donationCategory',
    name: 'donationCategory',
    component: Index,
    title: 'Donation Category',
    redirect: { name: 'donationCategory-list' },
    children: [
      
      {
        path: 'list',
        name: 'donationCategory-list',
        component: List,
      },
      
    ],
  },
]
